export const PAYMENT_REMINDER = (subscriptionFee: number): string[] => [
  "We hope you're enjoying the miindset app and experiencing the benefits from utilising it fully.",
  `In 3 days time your account will switch from the free version to the  £${subscriptionFee}pcm monthly subscription.`,
  "You can cancel at anytime after this time by visiting your account menu. Thank you for your ongoing support. The Miindset Team.",
];
